<template>
  <img src="/images/neck.png">
</template>

<script>
  export default {
   name: 'Neck' 
  }
</script>
